var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83976 3.6002C9.83976 3.86529 9.62486 4.0802 9.35976 4.0802L2.63976 4.0802C2.37466 4.0802 2.15976 3.86529 2.15976 3.6002C2.15976 3.3351 2.37466 3.1202 2.63976 3.1202L9.35976 3.1202C9.62486 3.1202 9.83976 3.3351 9.83976 3.6002Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83976 8.4002C9.83976 8.66529 9.62486 8.8802 9.35976 8.8802L2.63976 8.8802C2.37466 8.8802 2.15976 8.66529 2.15976 8.4002C2.15976 8.1351 2.37466 7.9202 2.63976 7.9202L9.35976 7.9202C9.62486 7.9202 9.83976 8.1351 9.83976 8.4002Z",
    fill: "#334155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69917 3.26078C9.88662 3.44824 9.88662 3.75216 9.69917 3.93961L7.77917 5.85961C7.59172 6.04706 7.2878 6.04706 7.10035 5.85961C6.9129 5.67216 6.9129 5.36824 7.10035 5.18078L8.68094 3.6002L7.10035 2.01961C6.9129 1.83215 6.9129 1.52824 7.10035 1.34078C7.2878 1.15333 7.59172 1.15333 7.77917 1.34078L9.69917 3.26078Z",
    fill: "#334155"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30035 8.73961C2.1129 8.55216 2.1129 8.24824 2.30035 8.06078L4.22035 6.14078C4.4078 5.95333 4.71172 5.95333 4.89917 6.14078C5.08662 6.32824 5.08662 6.63216 4.89917 6.81961L3.31858 8.4002L4.89917 9.98079C5.08662 10.1682 5.08662 10.4722 4.89917 10.6596C4.71172 10.8471 4.4078 10.8471 4.22035 10.6596L2.30035 8.73961Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/doubleArrow.dc520182c6c168bb9d747fd5698f9232.svg";
export { ForwardRef as ReactComponent };